// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  loginStatus: {
    data: null,
  },
  getAffirmationlistStatus: { data: null },
  createAffirmationStatus: { data: null },
  editAffirmationStatus: { data: null },
  deleteAffirmationStatus: { data: null },
};
